import classes from "./ServicosPage.module.css";

function ServicoPage() {
    return <main>
        <section id='servicos' className={classes.servicos}>
            <div className="interface">
                <h2 className="titulo">NOSSOS <span>SERVIÇOS.</span></h2>

                <div className={`row`}>

                    <div className={`${classes.servicosBox} col-12 col-md-6`}>
                        <i className="bi bi-code-slash"></i>
                        <h3>Desenvolvimento de Software</h3>
                        <p>
                            <strong>Aplicativos de coleta:</strong> Desenvolvimento de aplicações sob medida para coleta de dados em campo, com interface intuitiva, funcionamento online e offline e integração direta com bases de dados.
                            <br /><br />
                            <strong>Web crawlers:</strong> Criação de robôs automatizados para extração de dados em sites, portais e sistemas online, permitindo obter informações atualizadas de forma rápida, estruturada e escalável.
                            <br /><br />
                            <strong>Dashboards interativos:</strong> Desenvolvimento de painéis visuais dinâmicos que transformam dados em gráficos e indicadores, facilitando o acompanhamento de métricas e a tomada de decisão em tempo real.
                            <br /><br />
                            <strong>Integrações via API:</strong> Implementação de integrações entre sistemas por meio de APIs, possibilitando troca automática de dados, maior eficiência operacional e centralização das informações.
                            <br /><br />
                        </p>
                    </div>

                    <div className={`${classes.servicosBox} col-12 col-md-6`}>
                        <i className="bi bi-bar-chart-fill"></i>
                        <h3>Pesquisa de Mercado e Opinião</h3>
                        <p>
                            <strong>Pesquisa de mercado:</strong> Estudos estruturados para compreender o comportamento do mercado, identificar oportunidades, analisar concorrentes e apoiar decisões estratégicas com base em dados confiáveis.
                            <br /><br />
                            <strong>Opinião pública:</strong> Levantamento da percepção e posicionamento de públicos em relação a temas, marcas, produtos ou serviços, permitindo entender tendências e sentimentos da sociedade.
                            <br /><br />
                            <strong>Pesquisa de satisfação:</strong> Avaliação da experiência de clientes com produtos ou serviços, identificando pontos fortes, oportunidades de melhoria e níveis de fidelização.
                            <br /><br />
                            <strong>Segmentação de público:</strong> Análise e classificação de públicos com base em características demográficas, comportamentais ou geográficas, possibilitando estratégias mais direcionadas e eficazes.
                            <br /><br />

                        </p>
                    </div>

                    <div className={`${classes.servicosBox} col-12 col-md-6`}>
                        <i className="bi bi-clipboard-data-fill"></i>
                        <h3>Coleta de Dados</h3>
                        <p>
                            <strong>Pesquisas de campo (online e offline):</strong> Realização de levantamentos diretamente no local de interesse, utilizando dispositivos digitais que funcionam com ou sem conexão à internet, garantindo continuidade e segurança na coleta das informações.
                            <br /><br />
                            <strong>Aplicação de questionários:</strong> Execução de entrevistas estruturadas com base em formulários previamente definidos, assegurando padronização na abordagem e qualidade nas respostas obtidas.
                            <br /><br />
                            <strong>Coleta georreferenciada:</strong> Registro dos dados com coordenadas geográficas, permitindo identificar exatamente onde cada informação foi coletada e possibilitando análises espaciais mais precisas.
                            <br /><br />
                            <strong>Auditorias em campo:</strong> Verificação in loco de processos, atividades ou informações, com o objetivo de validar dados, garantir conformidade e aumentar a confiabilidade dos resultados.
                            <br /><br />

                        </p>
                    </div>                    

                    <div className={`${classes.servicosBox} col-12 col-md-6`}>
                        <i className="bi bi-graph-up-arrow"></i>
                        <h3>Tratamento e Análise de Dados</h3>
                        <p>
                            <strong>Limpeza e padronização:</strong> Organização e tratamento dos dados coletados, corrigindo inconsistências, removendo duplicidades e padronizando formatos para garantir qualidade e confiabilidade nas análises.
                            <br /><br />
                            <strong>Cruzamento de bases:</strong> Integração de diferentes fontes de dados, permitindo relacionar informações distintas e gerar uma visão mais completa e estratégica do cenário analisado.
                            <br /><br />
                            <strong>Modelagem estatística:</strong> Aplicação de métodos estatísticos para identificar padrões, testar hipóteses e gerar previsões, apoiando decisões com base em análises quantitativas robustas.
                            <br /><br />
                            <strong>Relatórios analíticos:</strong> Elaboração de relatórios claros e objetivos, com visualizações e interpretações dos dados, facilitando a compreensão dos resultados e a tomada de decisão.
                            <br /><br />

                        </p>
                    </div>

                    <div className={`${classes.servicosBox} col-12 col-md-6`}>
                        <i className="bi bi-map-fill"></i>
                        <h3>Inteligência Territorial</h3>
                        <p>
                            <strong>Mapas interativos:</strong> Desenvolvimento de mapas dinâmicos que permitem visualizar e explorar dados de forma intuitiva, facilitando a interpretação de informações e a identificação de padrões territoriais.
                            <br /><br />
                            <strong>Análise geoespacial:</strong> Estudo dos dados considerando sua localização geográfica, possibilitando identificar relações espaciais, tendências regionais e áreas estratégicas para atuação.
                            <br /><br />
                            <strong>Diagnósticos regionais:</strong> Avaliação detalhada de territórios com base em indicadores socioeconômicos, ambientais e operacionais, fornecendo uma visão completa para planejamento e tomada de decisão.
                            <br /><br />
                            <strong>Apoio a projetos:</strong> Suporte técnico especializado na elaboração, execução e monitoramento de projetos, utilizando dados territoriais para aumentar a eficiência e os resultados das iniciativas.
                            <br /><br />
                        </p>
                    </div>

                    {/* <div className={`${classes.servicosBox} col-12 col-md-6`}>
                        <i className="bi bi-hdd-network-fill"></i>
                        <h3>Infraestrutura e Hospedagem</h3>
                        <p>
                            <strong>Hospedagem de sistemas:</strong> Disponibilização de aplicações em ambientes confiáveis e escaláveis, garantindo acesso contínuo, desempenho adequado e suporte às demandas do negócio.
                            <br /><br />
                            <strong>Banco de dados:</strong> Estruturação e gerenciamento de bancos de dados eficientes e seguros, assegurando organização, integridade e rápido acesso às informações.
                            <br /><br />
                            <strong>Ambientes seguros:</strong> Implementação de camadas de segurança para proteção dos dados e sistemas, incluindo controle de acesso, criptografia e monitoramento constante.
                            <br /><br />
                            <strong>Alta disponibilidade:</strong> Configuração de infraestruturas resilientes que minimizam indisponibilidades, garantindo continuidade dos serviços mesmo em situações de falha.
                        </p>
                    </div> */}
                </div>
            </div>

        </section>

    </main>
}

export default ServicoPage;